import React, { useState, useEffect } from 'react';

import UncommittedExpenditureCreateListRow from '../committed_expenditures/UncommittedExpendituresCreateListRow';

import { combinePaginationUrl } from 'Helpers/urlService';

import Button from 'CommonComponents/Button';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

export default function PurchaseOrdersCreateUncommittedExpenditureCreate(props) {
    const [perPage, setPerPage] = useState(20);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);

    const [uncommittedExpenditures, setUncommittedExpenditures] = useState([]);
    const [isLoading, setIsLoading] = useState(1);
    const [errors, setErrors] = useState('');

    const defaultUrl = combinePaginationUrl(props.uncommittedExpendituresDetailsUrl, perPage, page);

    const combineFetchUrl = (p = null, pp = null) => {
        return combinePaginationUrl(props.uncommittedExpendituresDetailsUrl, pp || perPage, p || page);
    };

    useEffect(() => {
        fetchUncommittedExpenditures(defaultUrl);
    }, []);

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchUncommittedExpenditures(url);
    }

    const setCommittedExpenditures = (data) => {
        props.setCommittedExpenditures(data);
    };

    const fetchUncommittedExpenditures = (url = null) => {
        const fetchUrl = url || defaultUrl;
        setIsLoading(true);

        axios
            .get(fetchUrl)
            .then((res) => {
                const { to, from, last_page, total } = res.data;
                setTo(to);
                setFrom(from);
                setLastPage(last_page);
                setTotal(total);
                setUncommittedExpenditures(res.data.data);
                props.setUncommittedTotal(
                    res.data.data.reduce(
                        (acc, item) => acc + item.uncommitted || 0,
                        0, // initial value
                    ),
                );
                setIsLoading(false);
            })
            .catch((error) => {
                setUncommittedExpenditures([]);
                setIsLoading(false);
            });
    };

    const storeUncommittedExpenditures = (url = null) => {
        setIsLoading(true);

        axios
            .post(props.uncommittedExpendituresStoreUrl, {
                committedExpenditures: [...props.committedExpenditures],
                // When resuming a saved draft, reuse the existing group instead of creating a
                // new one so re-selecting never spawns a duplicate group (IB-610).
                uncommittedExpenditureGroupId: props.uncommittedExpenditureGroupId || null,
            })
            .then((res) => {
                setIsLoading(false);
                const { uncommittedExpenditureGroup } = res.data;
                props.setUncommittedExpenditureGroup(uncommittedExpenditureGroup);
                props.nextStep(2);
            })
            .catch((error) => {
                setErrors('Please select at least 1 uncommitted expenditure to proceed');
                setIsLoading(false);
            });
    };

    return (
        <div>
            <div className="table__card tw-mt-4">
                <div>
                    <h5 className="table__header">{$t('Select Budget')}</h5>
                    <div className="table__pagination-info">
                        <PaginationInfo to={to} from={from} total={total} />
                        <TablePagination lastPage={lastPage} pageChange={pageChange} />
                    </div>
                </div>
                {errors !== '' && (
                    <div className="alert alert-danger">
                        <ul>
                            <li>{errors}</li>
                        </ul>
                    </div>
                )}
                <div className="inbud-table_wrapper tw-mt-6">
                    <table className="inbud-table">
                        <thead>
                            <tr>
                                <th className="tw-w-1/12"></th>
                                <th className="tw-w-2/12 tw-text-left">{$t('Name')}</th>
                                <th className="tw-w-1/12">{$t('Cash')}</th>
                                {props.vikEnabled && <th className="tw-w-1/12">{$t('VIK')}</th>}
                                <th className="tw-w-1/12">{$t('Total')}</th>
                                <th className="tw-w-1/12">{$t('Committed')}</th>
                                <th className="tw-w-1/12">{$t('Uncommitted')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!isLoading &&
                                uncommittedExpenditures.length > 0 &&
                                uncommittedExpenditures.map((uncommittedExpenditure) => {
                                    return (
                                        <UncommittedExpenditureCreateListRow
                                            key={uncommittedExpenditure.model + '_' + uncommittedExpenditure.id}
                                            uncommittedExpenditure={uncommittedExpenditure}
                                            uncommittedExpenditures={uncommittedExpenditures}
                                            committedExpenditures={props.committedExpenditures}
                                            setCommittedExpenditures={setCommittedExpenditures}
                                            vikEnabled={props.vikEnabled}
                                        />
                                    );
                                })}
                            {!isLoading && uncommittedExpenditures.length === 0 && (
                                <tr>
                                    <td colSpan={props.vikEnabled ? 7 : 6}>{$t('There are no uncommitted expenditures')}.</td>
                                </tr>
                            )}
                            {isLoading && (
                                <tr>
                                    <td colSpan={props.vikEnabled ? 7 : 6}>{$t('Loading')}...</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="d-flex justify-content-end py-3">
                <Button variant="primary" onClick={storeUncommittedExpenditures} disabled={isLoading}>
                    {$t('Next')}
                </Button>
            </div>
        </div>
    );
}
